export default [
  {
    text: 'aggregatorSyncs.table.user',
    value: 'user',
    default: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'aggregatorSyncs.table.status',
    value: 'status',
    default: true,
    align: 'left',
  },
  {
    text: 'aggregatorSyncs.table.createdAt',
    value: 'createdAt',
    default: true,
    type: 'slot',
    align: 'left',
  },
  {
    text: 'aggregatorSyncs.table.finishedAt',
    value: 'finishedAt',
    default: true,
    type: 'slot',
    align: 'left',
  },
  { text: '', value: 'data-table-expand', default: true },
];
